export default "__VITE_ASSET__DdfYptOR__"